import type { IHtmlHighlightInput } from "~/typings/annotate/annotation";

/**
 * What the annotator does once a selection has (or has not) been turned into
 * a pending highlight. Pure so both call sites (desktop mouse-up, mobile
 * selectionchange) share one behaviour and it can be tested without the DOM.
 *
 *  - no highlight (the selection's start or end sits outside the indexed
 *    article text — an image, a caption, page chrome): clear the pending
 *    state, warn once, and LEAVE the learner's native selection alone: they
 *    may be copying. This used to throw and the learner saw nothing
 *    (WEB-SPACE-H).
 *  - a highlight: commit it, dismiss any earlier warning, and on desktop
 *    collapse the native selection (the popover takes over); mobile keeps it
 *    so the reference element stays measurable.
 */
export interface SelectionOutcomeEffects {
  clearPending: () => void;
  commit: (highlight: IHtmlHighlightInput) => void;
  warn: () => void;
  dismissWarning: () => void;
  emptySelection: () => void;
}

export function applySelectionOutcome(
  highlight: IHtmlHighlightInput | null,
  surface: "desktop" | "mobile",
  effects: SelectionOutcomeEffects,
): "rejected" | "committed" {
  if (!highlight) {
    effects.clearPending();
    effects.warn();
    return "rejected";
  }
  if (surface === "desktop") effects.emptySelection();
  effects.dismissWarning();
  effects.commit(highlight);
  return "committed";
}
